import { create } from 'zustand'
import { apiService } from '../services/api.js'

export const useUserStore = create((set, get) => ({
  // State
  userProfile: null,
  states: [],
  isLoadingProfile: false,
  isLoadingStates: false,
  error: null,

  // Actions
  
  // Fetch user profile data
  fetchUserProfile: async (companyUrl) => {
    const { userProfile, isLoadingProfile } = get()
    
    // Prevent duplicate calls if already loading or data exists
    if (isLoadingProfile || userProfile) {
      return { success: true, data: userProfile }
    }
    
    set({ isLoadingProfile: true, error: null })
    
    try {
      const result = await apiService.get(`/${companyUrl}/getuser`)
      
      if (result.success) {
        // Handle array response - take the first user object
        const userProfileData = Array.isArray(result.data) ? result.data[0] : result.data
        
        set({ 
          userProfile: userProfileData,
          isLoadingProfile: false 
        })
        
        return { success: true, data: userProfileData }
      } else {
        set({ 
          error: result.error,
          isLoadingProfile: false 
        })
        return { success: false, error: result.error }
      }
    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch user profile'
      console.error('❌ Error fetching user profile:', errorMessage)
      set({ 
        error: errorMessage,
        isLoadingProfile: false 
      })
      return { success: false, error: errorMessage }
    }
  },

  // Fetch states data
  fetchStates: async (companyUrl) => {
    const { states, isLoadingStates } = get()
    
    // Prevent duplicate calls if already loading or data exists
    if (isLoadingStates || (states && states.length > 0)) {
      return { success: true, data: states }
    }
    
    set({ isLoadingStates: true, error: null })
    
    try {
      const result = await apiService.get(`/${companyUrl}/getstates`)
      
      if (result.success) {
        
        set({ 
          states: result.data,
          isLoadingStates: false 
        })
        
        return { success: true, data: result.data }
      } else {
        set({ 
          error: result.error,
          isLoadingStates: false 
        })
        return { success: false, error: result.error }
      }
    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch states'
      console.error('❌ Error fetching states:', errorMessage)
      set({ 
        error: errorMessage,
        isLoadingStates: false 
      })
      return { success: false, error: errorMessage }
    }
  },

  // Update user profile locally (for form updates)
  updateUserProfile: (updates) => {
    const currentProfile = get().userProfile
    if (currentProfile) {
      const updatedProfile = { ...currentProfile, ...updates }
      set({ userProfile: updatedProfile })
    }
  },

  // Clear user data
  clearUserData: () => {
    set({
      userProfile: null,
      states: [],
      isLoadingProfile: false,
      isLoadingStates: false,
      error: null
    })
  },

  // Clear error
  clearError: () => {
    set({ error: null })
  }
}))